import {
  LOG_OUT,
  ACTIVITIES_LOADING,
  ACTIVITIES_SUCCESS,
  ACTIVITIES_FAILED,
  ACTIVITY_SELECTED,
  ACTIVITY_UNSELECTED,
  CREATE_ACTIVITIES_LOADING,
  CREATE_ACTIVITIES_SUCCESS,
  CREATE_ACTIVITIES_FAILED,
  UPDATE_ACTIVITIES_LOADING,
  UPDATE_ACTIVITIES_SUCCESS,
  UPDATE_ACTIVITIES_FAILED,
  DELETE_ACTIVITIES_LOADING,
  DELETE_ACTIVITIES_SUCCESS,
  DELETE_ACTIVITIES_FAILED,
  SUBCATEGORIES_LOADING,
  SUBCATEGORIES_SUCCESS,
  SUBCATEGORIES_FAILED
} from "../constants/actionTypes"

import type { Activity, ActivitySubcategory, ReducerAction } from "../constants/types"

type ActivitiesState = {
  isLoading: boolean
  activities: Activity[]
  categories: ActivitySubcategory[]
  categoriesStatus: "idle" | "loading" | "succeeded" | "failed"
  selectedActivityId: string | undefined
}

function replaceActivity(list: Activity[], next: Activity): Activity[] {
  return list.map(a => (a.id === next.id ? next : a))
}

function removeActivity(list: Activity[], id: string): Activity[] {
  return list.filter(a => a.id !== id)
}

const initialState: ActivitiesState = {
  isLoading: false,
  activities: [],
  categories: [],
  categoriesStatus: "idle",
  selectedActivityId: undefined
}

export default function activitiesReducer(
  state: ActivitiesState = initialState,
  action: ReducerAction
): ActivitiesState {
  switch (action.type) {
    // =============================================================================
    case ACTIVITIES_LOADING:
      return { ...state, isLoading: true }
    case ACTIVITIES_SUCCESS: {
      const payload = action.payload as unknown
      const activities = Array.isArray(payload) ? (payload as Activity[]) : []

      return { ...state, isLoading: false, activities }
    }
    case ACTIVITIES_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case ACTIVITY_SELECTED:
      return { ...state, selectedActivityId: action.payload as string }
    case ACTIVITY_UNSELECTED:
      return { ...state, selectedActivityId: undefined }

    // =============================================================================
    case CREATE_ACTIVITIES_LOADING:
      return { ...state, isLoading: true }
    case CREATE_ACTIVITIES_SUCCESS: {
      const activity = action.payload as Activity

      return {
        ...state,
        isLoading: false,
        activities: [...state.activities, activity],
        selectedActivityId: activity.id as string
      }
    }
    case CREATE_ACTIVITIES_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case UPDATE_ACTIVITIES_LOADING:
      return { ...state, isLoading: true }
    case UPDATE_ACTIVITIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activities: replaceActivity(state.activities, action.payload as Activity)
      }
    case UPDATE_ACTIVITIES_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case DELETE_ACTIVITIES_LOADING:
      return { ...state, isLoading: true }
    case DELETE_ACTIVITIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activities: removeActivity(state.activities, action.payload as string)
      }
    case DELETE_ACTIVITIES_FAILED:
      return { ...state, isLoading: false }

    // =============================================================================
    case SUBCATEGORIES_LOADING:
      return { ...state, isLoading: true, categoriesStatus: "loading" }
    case SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        categories: (action.payload as ActivitySubcategory[]) ?? [],
        categoriesStatus: "succeeded"
      }
    case SUBCATEGORIES_FAILED:
      return { ...state, isLoading: false, categoriesStatus: "failed" }

    // =============================================================================
    case LOG_OUT:
      return initialState

    // =============================================================================
    default:
      break
  }
  return state
}
